// extracted by mini-css-extract-plugin
export default {"descriptionAlignmentWrapper":"DPu1fG","richContent":"PffucE","richContentOld":"SjkWqb","showMoreOrLess":"jxiFxb","showMoreOrLessOld":"dcMWsg"};